import { SubscriptionCookieData } from "reg-ui-client/dist/lib/interfaces";
import { Locale } from "./constants";

export type SubscriptionType = "BBG" | "BW";

export interface User {
    userRole?: string;
    linkedAccounts?: string;
    status?: string;
    newsletterIds?: string[];
    referralToken?: string;
    firstName?: string;
    email?: string;
    subscriptionsData?: SubscriptionCookieData[];
}

export interface BaseDetails {
    agentId?: string;
    sessionId?: string;
    sessionKey?: string;
    userId?: string;
    user?: User | null;
}

export interface UserInfoDetails extends BaseDetails {
    subscription?: null | {
        type?: SubscriptionType,
        number?: number;
    }
}

export type NAV_ENVIRONMENT = "staging" | "production";

export type NavParams = {
    environment: NAV_ENVIRONMENT;
    proxy?: string;
    useAWS?: boolean;
    host?: string;
    locale?: Locale;
}

export enum REGIONS {
    AFRICA = "AFRICA",
    ASIA = "APAC",
    EUROPE = "EUR",
    JAPAN = "JAPAN",
    MIDDLE_EAST = "MIDEAST",
    US = "AMER",
    UK = "UK",
    LATAM = "LATAM"
}

export enum BREAKING_NEWS_REGIONS {
    AFRICA = "AFRICA",
    ASIA = "APAC",
    EUROPE = "EUR",
    GLOBAL = "GLOBAL",
    JAPAN = "JAPAN",
    MIDDLE_EAST = "MIDEAST",
    US = "AMER",
    UK = "UK",
    LATAM = "LATAM"
}

export enum BREAKING_NEWS_LANGUAGES {
    ENGLISH = "english",
    JAPANESE = "japanese"
}

export enum PUBLICATION_STATES {
    PUBLISHED = "PUBLISHED",
    DRAFT = "DRAFT"
}

export type SignInButtons = {
    desktopSignInButton?: Element,
    mobileSignInButton?: Element
};
